import { useEffect, useState, RefObject } from "react";

interface Dimensions {
  width: number;
  height: number;
}

export const useAspectRatioDimensions = (
  ref: RefObject<HTMLElement | null>,
  targetWidth: number,
  targetHeight: number,
): Dimensions => {
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    const calculateDimensions = () => {
      if (!ref.current) {
        throw new Error("useAspectRatioDimensions: ref.current is not defined");
      }

      const containerWidth = ref.current.clientWidth;
      const containerHeight = ref.current.clientHeight;
      const containerAspectRatio = containerWidth / containerHeight;

      const targetAspectRatio = targetWidth / targetHeight;

      let width: number;
      let height: number;

      if (containerAspectRatio > targetAspectRatio) {
        height = containerHeight;
        width = height * targetAspectRatio;
      } else {
        width = containerWidth;
        height = width / targetAspectRatio;
      }

      setDimensions({ width, height });
    };

    if (!ref.current) {
      throw new Error("useAspectRatioDimensions: ref.current is not defined");
    }

    calculateDimensions();

    const resizeObserver = new ResizeObserver(calculateDimensions);
    resizeObserver.observe(ref.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref, targetWidth, targetHeight]);

  return dimensions;
};
